export default __webpack_public_path__ + "static/media/grade-white.b0609249.svg";